import React from 'react';
import styles from './ChartExplorerPageHeader.module.css';

const ChartExplorerPageHeader = (props) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>Chart Explorer</div>
    </div>
  );
};

export default ChartExplorerPageHeader;
